export enum NAV_VALUES {
  EDIT = 'edit-ticket',
  WATCH_TICKET = 'watch-ticket',
  LIST_TICKET = 'list-ticket',
}
